import { render, staticRenderFns } from "./ItemTypeCalendarView.vue?vue&type=template&id=6020c9b0"
import script from "./ItemTypeCalendarView.vue?vue&type=script&lang=js"
export * from "./ItemTypeCalendarView.vue?vue&type=script&lang=js"
import style0 from "./ItemTypeCalendarView.vue?vue&type=style&index=0&id=6020c9b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports